var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0301 4.87539L7.52372 7.39024C7.73746 7.98414 7.82606 8.97883 6.90543 10.2027C6.84105 10.2888 6.75884 10.3599 6.66443 10.4113C6.57002 10.4627 6.46563 10.4931 6.3584 10.5004C6.34059 10.5004 6.32325 10.5004 6.30543 10.5004C6.20688 10.5004 6.10929 10.481 6.01824 10.4433C5.92719 10.4056 5.84447 10.3503 5.77481 10.2806L3.51262 8.01602L1.51434 10.0157C1.44397 10.0861 1.34854 10.1256 1.24903 10.1256C1.14952 10.1256 1.05408 10.0861 0.983715 10.0157C0.913349 9.94534 0.873819 9.84991 0.873819 9.75039C0.873819 9.65088 0.913349 9.55545 0.983715 9.48508L2.9834 7.4868L0.71934 5.22274C0.64492 5.14823 0.587027 5.05888 0.549429 4.96051C0.511831 4.86214 0.49537 4.75695 0.501118 4.6518C0.506867 4.54665 0.534696 4.44388 0.582793 4.3502C0.630891 4.25651 0.698179 4.17401 0.780277 4.10805C1.97184 3.14664 3.11231 3.33555 3.61153 3.49211L6.12403 0.970707C6.19367 0.901045 6.27636 0.845785 6.36737 0.808083C6.45837 0.770382 6.55591 0.750977 6.65442 0.750977C6.75292 0.750977 6.85046 0.770382 6.94147 0.808083C7.03248 0.845785 7.11516 0.901045 7.18481 0.970707L10.0297 3.81508C10.1703 3.95566 10.2493 4.14631 10.2494 4.34514C10.2495 4.54397 10.1706 4.73469 10.0301 4.87539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.88f864bba96725546a3bd3496044abc3.svg";
export { ForwardRef as ReactComponent };